import { Title } from "@unit-finance/unit-node-sdk";

import { IStringOption } from "../input/StringOptionSelect";

export const TITLE_OPTIONS: Array<IStringOption<Title>> = [
    { label: "President", value: "President" },
    { label: "CEO", value: "CEO" },
    { label: "COO", value: "COO" },
    { label: "CFO", value: "CFO" },
    { label: "CIO", value: "CIO" },
    { label: "VP", value: "VP" },
    { label: "AVP", value: "AVP" },
    { label: "Benefits Administration Officer", value: "BenefitsAdministrationOfficer" },
    { label: "Treasurer", value: "Treasurer" },
    { label: "Secretary", value: "Secretary" },
    { label: "Controller", value: "Controller" },
    { label: "Manager", value: "Manager" },
    { label: "Partner", value: "Partner" },
    { label: "Member", value: "Member" },
];

export const SSN_REGEX = /^((\d{9})|(\d{3}-\d{2}-\d{4}))$/;
